<template>
    <div @click.capture.stop="click" class="cursor-pointer">
        <div>
            <q-img v-show="!videoUrl" :src="params.image_url" />
            <q-video
                v-if="videoUrl"
                :src="videoUrl"
                :ratio="16/9"
            />
        </div>
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'ButtonImage',
    mixins: [uiControlMixin],
    data () {
        return {
            videoUrl: undefined,
        };
    },
    mounted () {
        if (!this.params.image_url) {
            this.videoUrl = this.params.video;
        }
    },
    methods: {
        click () {
            if (this.params.to === 'video') {
                this.videoUrl = this.params.video;
                return;
            }
            this.$emit('click');
        },
    },
};
</script>

<style scoped>

</style>
